import * as React from 'react';

const Boat = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 48" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
            <path
                strokeWidth={3}
                d="M1.5 46.526a11.02 11.02 0 0 0 9-3 9.094 9.094 0 0 0 13.5 0 9.094 9.094 0 0 0 13.5 0 11.02 11.02 0 0 0 9 3M43.514 40.542a12.5 12.5 0 0 0 2.858-3.908A1.5 1.5 0 0 0 45 34.526H3a1.5 1.5 0 0 0-1.372 2.108A12.9 12.9 0 0 0 5.2 41.182"
            />
            <path
                strokeWidth={3}
                d="M22.5 34.526V4.06a2.534 2.534 0 0 0-4.568-1.512L4.542 23.2A1.5 1.5 0 0 0 5.8 25.522l16.696-.024M31.262 11.822a1.5 1.5 0 0 0-2.762.812v15.892h10.752a1.502 1.502 0 0 0 1.262-2.312Z"
            />
        </g>
    </svg>
);
export default Boat;
